
import { mapState } from 'vuex'
import { setMetaRobots } from '@/utils/utils'
export default {
  name: 'ShippingPolicy',
  head() {
    return {
      title: 'Chính sách vận chuyển - Togihome',
      meta: [setMetaRobots(false)]
    }
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting
    })
  },
  mounted() {
    document.title = 'Chính sách vận chuyển - Togihome'
  }
}
